import { render, staticRenderFns } from "./specialCourse.vue?vue&type=template&id=58cbd0c2&scoped=true"
import script from "./specialCourse.vue?vue&type=script&lang=ts"
export * from "./specialCourse.vue?vue&type=script&lang=ts"
import style0 from "./specialCourse.vue?vue&type=style&index=0&id=58cbd0c2&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58cbd0c2",
  null
  
)

export default component.exports